import { getQuantityDescription } from "@affinity/constants/FormatHelpers";
import GetQuoteState, { initialState } from "@affinity/Store/AffinityGetQuoteState";
import { AffinityDelivery, AffinityProduct, GetQuoteStep, PriceOptionViewModel, QuantityViewModel } from "@affinity/Store/StoreTypes";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductModel, ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import { Draft, isDraft } from "immer";
import defaultTo from "lodash/defaultTo"

const reducer = {
    "Affinity/GetQuote/Initialise": (
        draft: Draft<GetQuoteState>,
        action: { productRegular: ProductModel, productPremium: ProductModel, quantityRegular: QuantityViewModel, quantityPremium: QuantityViewModel }
    ) => {
        draft.currentStep = GetQuoteStep.BasicDetails;
        draft.productRegular = action.productRegular;
        draft.productPremium = action.productPremium;
        draft.quantityRegular = action.quantityRegular;
        draft.quantityPremium = action.quantityPremium;
        draft.stepValues = {
            [GetQuoteStep.BasicDetails]: undefined,
            [GetQuoteStep.Quotation]: undefined,
            [GetQuoteStep.Complete]: undefined
        };
        draft.isInitialised = true;
    },
    "Affinity/GetQuote/BasicDetails/Set": (
        draft: Draft<GetQuoteState>,
        action: { selectedProduct: AffinityProduct, postcode: string, emailAddress: string, allowMarketing: boolean },
    ) => {
        draft.currentStep = GetQuoteStep.Quotation;
        draft.selectedProduct = action.selectedProduct;
        draft.postcode = action.postcode;
        draft.emailAddress = action.emailAddress;
        draft.allowMarketing = action.allowMarketing;
        draft.stepValues![GetQuoteStep.BasicDetails] = action.postcode;
    },
    "Affinity/GetQuote/Quotation/Update": (
        draft: Draft<GetQuoteState>,
        action: { deliveryCheapest: PriceOptionViewModel, deliverySoonest: PriceOptionViewModel, hasAttemped: boolean },
    ) => {
        draft.deliveryCheapest = action.deliveryCheapest;
        draft.deliverySoonest = action.deliverySoonest;
        draft.hasAttemped = action.hasAttemped;
    },
    "Affinity/GetQuote/Quotation/Set": (
        draft: Draft<GetQuoteState>,
        action: { quantity: number, selectedDelivery: AffinityDelivery },
    ) => {
        draft.currentStep = GetQuoteStep.Complete;
        draft.quantity = action.quantity;
        draft.selectedDelivery = action.selectedDelivery;
        draft.stepValues![GetQuoteStep.Quotation] = getQuantityDescription(action.quantity);
    },
    "Affinity/GetQuote/Change": (
        draft: Draft<GetQuoteState>,
        action: { newStep: GetQuoteStep },
    ) => {
        if (action.newStep === GetQuoteStep.Complete) {
            return;
        }
        if (action.newStep === GetQuoteStep.BasicDetails) {
            draft.deliveryCheapest = undefined;
            draft.deliverySoonest = undefined;
            draft.quantity = undefined;
            draft.selectedDelivery = AffinityDelivery.Cheapest;
            draft.hasAttemped = false;
        }

        draft.currentStep = action.newStep;
    }
}

export default createTypedReducerWithImmer(initialState, reducer);
// export default createTypedReducerWithImmer(mockState, reducer);